var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50375 0.5C9.50375 0.5 11.3281 1.76786 13.4077 2.625C15.3744 3.43948 16.9494 3.52925 16.9988 3.53207C16.9997 3.53212 17.0001 3.53214 17 3.53214V9.83572C17 11.5679 16.7185 13.4571 14.3911 15.5857C12.0676 17.7107 9.5 18.5 9.5 18.5C9.5 18.5 6.93618 17.7143 4.60886 15.5857C2.28528 13.4607 2 11.5679 2 9.83572V3.53214C2 3.53214 3.5991 3.45357 5.59985 2.625C7.67943 1.76786 9.50375 0.5 9.50375 0.5ZM13.7803 7.53033C14.0732 7.23744 14.0732 6.76256 13.7803 6.46967C13.4874 6.17678 13.0126 6.17678 12.7197 6.46967L8.25 10.9393L6.78033 9.46967C6.48744 9.17678 6.01256 9.17678 5.71967 9.46967C5.42678 9.76256 5.42678 10.2374 5.71967 10.5303L7.71967 12.5303C8.01256 12.8232 8.48744 12.8232 8.78033 12.5303L13.7803 7.53033Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.020e82990c7de8e135388c7ac15fffbd.svg";
export { ForwardRef as ReactComponent };